import UploadComponent from 'components/uploadComponent/uploadComponent';
import { observer } from 'mobx-react';
import { Dialog } from 'primereact/dialog';
import classes from './BulkJobUpload.module.scss';
import DatavalidationComponent from './components/DataValidationComponent/DataValidationComponent';
import { useBulkJobUpload } from './useBulkJobUpload';

const BulkJobUploadModal = () => {
  const {
    fileUploaded,
    validationData,
    handleDownloadTemplate,
    isFileUploading,
    handleUploadFile,
    onClose,
    visibility,
    cancelUploadedFileCallback
  } = useBulkJobUpload();

  return (
    <Dialog
      blockScroll
      resizable={false}
      draggable={false}
      headerClassName={classes.modalHeader}
      header={fileUploaded ? 'Data Validation' : ''}
      visible={visibility}
      style={{
        width: fileUploaded ? '90vw' : '30vw',
        maxHeight: '90vh',
        position: 'relative'
      }}
      onHide={onClose}
    >
      {!fileUploaded ? (
        <UploadComponent
          toggleVisibility={onClose}
          handleDownloadTemplate={handleDownloadTemplate}
          handleUploadFile={handleUploadFile}
          isFileUploading={isFileUploading}
        />
      ) : (
        <DatavalidationComponent
          goBack={cancelUploadedFileCallback}
          data={validationData}
          successCallBack={onClose}
        />
      )}
    </Dialog>
  );
};

export default observer(BulkJobUploadModal);
